import styles from "../../styles/pages/Home/HomePage.module.css";
import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { LangContext } from '../../context/LangContext';
import { ThemeContext } from '../../context/ThemeContext';

const translations = {
  ru: {
    documentTitle: "Добро пожаловать в CRM!",
    welcomeTitle: "Добро пожаловать в Crypto-Affiliates CRM!",
    welcomeMessage: "Спасибо, что присоединились к нашей системе управления взаимоотношениями с клиентами, разработанной специально для крипто-аффилиатов. Здесь вы найдете все необходимые инструменты для эффективного управления вашими лидами, отслеживания транзакций и взаимодействия с вашей командой.",
    featuresTitle: "Основные возможности:",
    features: {
      leads: {
        title: "Управление лидами:",
        description: "Отслеживайте и обновляйте информацию о ваших потенциальных клиентах."
      },
      employees: {
        title: "Управление сотрудниками:",
        description: "Контролируйте работу вашей команды и распределяйте задачи."
      },
      transactions: {
        title: "Управление транзакциями:",
        description: "Просматривайте депозиты, выводы и бонусы ваших пользователей."
      },
      analytics: {
        title: "Аналитика и отчеты:",
        description: "Получайте данные для оценки эффективности вашей работы (в разработке)."
      }
    },
    gettingStartedTitle: "С чего начать?",
    gettingStartedMessage: "Перейдите в разделы \"Лиды\", \"Сотрудники\" или \"Транзакции\" в боковом меню, чтобы начать работу.",
    startButton: "Перейти к управлению лидами"
  },
  en: {
    documentTitle: "Welcome to CRM!",
    welcomeTitle: "Welcome to Crypto-Affiliates CRM!",
    welcomeMessage: "Thank you for joining our customer relationship management system, designed specifically for crypto affiliates. Here you will find all the necessary tools to effectively manage your leads, track transactions, and interact with your team.",
    featuresTitle: "Key Features:",
    features: {
      leads: {
        title: "Lead Management:",
        description: "Track and update information about your potential clients."
      },
      employees: {
        title: "Employee Management:",
        description: "Monitor your team's work and delegate tasks."
      },
      transactions: {
        title: "Transaction Management:",
        description: "View your users' deposits, withdrawals, and bonuses."
      },
      analytics: {
        title: "Analytics and Reports:",
        description: "Get data to evaluate your performance (in development)."
      }
    },
    gettingStartedTitle: "Getting Started?",
    gettingStartedMessage: "Navigate to the \"Leads\", \"Employees\", or \"Transactions\" sections in the side menu to get started.",
    startButton: "Go to Lead Management"
  },
};

export const HomePage = () => {
  const { langSelected } = useContext(LangContext);
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';
  const t = translations[langSelected] || translations.ru;

  useEffect(() => {
    document.title = t.documentTitle;
  }, [t.documentTitle]);

  return (
    <div className={`${styles.container} ${isDark ? styles.darkContainer : ''}`}>
      <h1 className={`${styles.welcomeTitle} ${isDark ? styles.darkTextMain : ''}`}>{t.welcomeTitle}</h1>
      <p className={`${styles.welcomeMessage} ${isDark ? styles.darkTextSecondary : ''}`}>
        {t.welcomeMessage}
      </p>

      <div className={styles.features}>
        <h2 className={`${styles.sectionTitle} ${isDark ? styles.darkTextMain : ''}`}>{t.featuresTitle}</h2>
        <ul className={styles.featuresList}>
          <li className={`${styles.featureItem} ${isDark ? styles.darkTextSecondary : ''}`}>
            <DashboardIcon className={`${styles.featureIcon} ${isDark ? styles.darkIcon : ''}`} />
            <span className={`${styles.featureText} ${isDark ? styles.darkTextMain : ''}`}>{t.features.leads.title}</span> {t.features.leads.description}
          </li>
          <li className={`${styles.featureItem} ${isDark ? styles.darkTextSecondary : ''}`}>
            <PeopleIcon className={`${styles.featureIcon} ${isDark ? styles.darkIcon : ''}`} />
            <span className={`${styles.featureText} ${isDark ? styles.darkTextMain : ''}`}>{t.features.employees.title}</span> {t.features.employees.description}
          </li>
          <li className={`${styles.featureItem} ${isDark ? styles.darkTextSecondary : ''}`}>
            <AttachMoneyIcon className={`${styles.featureIcon} ${isDark ? styles.darkIcon : ''}`} />
            <span className={`${styles.featureText} ${isDark ? styles.darkTextMain : ''}`}>{t.features.transactions.title}</span> {t.features.transactions.description}
          </li>
          <li className={`${styles.featureItem} ${isDark ? styles.darkTextSecondary : ''}`}>
            <ShowChartIcon className={`${styles.featureIcon} ${isDark ? styles.darkIcon : ''}`} />
            <span className={`${styles.featureText} ${isDark ? styles.darkTextMain : ''}`}>{t.features.analytics.title}</span> {t.features.analytics.description}
          </li>
        </ul>
      </div>

      <div className={styles.gettingStarted}>
        <h2 className={`${styles.sectionTitle} ${isDark ? styles.darkTextMain : ''}`}>{t.gettingStartedTitle}</h2>
        <p className={`${styles.gettingStartedMessage} ${isDark ? styles.darkTextSecondary : ''}`}>
          {t.gettingStartedMessage}
        </p>
        <Link to="/lead" className={styles.startButton}>
          {t.startButton}
        </Link>
      </div>
    </div>
  );
};